import RteParser from './RteParser.vue'

export default RteParser
